import React from "react";
import { Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JetztBeitragBerechnen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="21899" id="ctabanner" className="bg-white px-3 sm:px-4 ![padding-top:144px] ![padding-bottom:144px]">
  <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
    <div className="rounded-[1rem] bg-[#FF6F61] p-8 sm:p-12 md:p-16 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-8 min-h-[250px] sm:min-h-[300px] transition-all duration-300 hover:shadow-2xl justify-end">
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-tight max-w-2xl">
        Bereit für einen Arbeitsplatz,<br />auf den du dich freust?
      </h2>
      <Link to="/kontakt" className="w-full sm:w-auto">
        <Button size="lg" className="h-14 w-full sm:w-auto rounded-full bg-white/20 backdrop-blur-sm border border-white/30 hover:bg-white/30 text-white text-base font-semibold transition-all duration-300 hover:-translate-y-0.5 flex-shrink-0" style={{
            paddingLeft: '40px',
            paddingRight: '40px'
          }}>
          Jetzt kontaktieren
        </Button>
      </Link>
    </div>
  </div>
</section>;
}